

























import { defineComponent, computed } from "@vue/composition-api";
import UserModel from "@/ts/models/userClass";
import ImageModel from "@/ts/models/imageClass";

export default defineComponent({
  name: "UserCard",

  props: {
    user: UserModel
  },

  setup(props) {
    var image: any = computed(() => {
      if (props.user) {
        if (props.user.image) {
          return props.user.image;
        } else {
          return new ImageModel("avatar");
        }
      }
    });

    return {
      image
    };
  }
});
